import stringify from 'json-stringify-safe';
import {
  CheckoutDataDecodeError,
  StatusDataDecodeError,
  IntegrationDataDecodeError,
} from '@wix/pricing-plans-router-utils';
import { MessageCode } from '../types/common';

export class AcceptPaymentsFeatureMissingError extends Error {
  constructor() {
    super('Accept payments feature missing');
    Object.setPrototypeOf(this, AcceptPaymentsFeatureMissingError.prototype);
  }
}

export class PurchaseLimitExceededError extends Error {
  constructor() {
    super('Purchase limit exceeded.');
    Object.setPrototypeOf(this, PurchaseLimitExceededError.prototype);
  }
}

export function errorToMessage(e: Error): MessageCode {
  if (e instanceof PurchaseLimitExceededError) {
    return MessageCode.PURCHASE_LIMIT_ERROR;
  }
  if (e instanceof AcceptPaymentsFeatureMissingError) {
    return MessageCode.ACCEPT_PAYMENTS_FEATURE_MISSING;
  }
  if (e instanceof CheckoutDataDecodeError) {
    return MessageCode.CHECKOUT_PAYLOAD_DECODE_FAILED;
  }
  if (e instanceof StatusDataDecodeError) {
    return MessageCode.STATUS_PAYLOAD_DECODE_FAILED;
  }
  if (e instanceof IntegrationDataDecodeError) {
    return MessageCode.INTEGRATION_DATA_DECODE_FAILED;
  }
  return MessageCode.UNKNOWN_ERROR;
}

export function messageToText(message: MessageCode): string {
  switch (message) {
    case MessageCode.PURCHASE_LIMIT_ERROR:
      return 'pp.1-purchase-plan-error';
    case MessageCode.PLAN_NOT_FOUND:
      return 'pp.checkout-missing-plan';
    case MessageCode.CHECKOUT_DEMO:
      return 'pp.demo-checkout-message';
    case MessageCode.ACCEPT_PAYMENTS_FEATURE_MISSING:
      return 'pp.checkout-accept-payments-feature-missing';
    default:
      return 'pp.generic-purchase-error';
  }
}

export function isMessageInformational(message: MessageCode) {
  switch (message) {
    case MessageCode.CHECKOUT_DEMO:
      return true;
    default:
      return false;
  }
}

export const toError = (e: unknown): Error =>
  e instanceof Error ? e : new Error(typeof e === 'string' ? e : stringify(e));

export const getApplicationErrorCode = (e: any) => e?.response?.data?.details?.applicationError?.code;
